var map = {
	"./colorBlack.png": 13,
	"./colorBlue.png": 14,
	"./colorRed.png": 15,
	"./colorSilver.png": 16,
	"./colorWhite.png": 17,
	"./logo.png": 2,
	"./m3pblack.png": 18,
	"./m3pblue.png": 19,
	"./m3pred.png": 20,
	"./m3psilver.png": 21,
	"./m3pwhite.png": 22,
	"./m3sblack.png": 23,
	"./m3sblue.png": 24,
	"./m3sred.png": 25,
	"./m3ssilver.png": 26,
	"./m3swhite.png": 3
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;